var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BtnFavorite',_vm._b({staticClass:"v-btn--favorite",attrs:{"ripple":false,"block":""}},'BtnFavorite',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }